import { render, staticRenderFns } from "./ModalCreateNewFolder.vue?vue&type=template&id=f0065934"
import script from "./ModalCreateNewFolder.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports